import { Footer, Options } from 'type/Options'

function extractFooter(raw: Footer | boolean | undefined): Footer {
  if (raw == null || raw === true) return {}
  if (raw === false) return { on: false }
  return raw
}

function buildLink(value: string | undefined): string | undefined {
  value = value?.trim()
  if (!value) return undefined
  try {
    value = value.replace(/^https?:\/*/i, '')
    const url = new URL('https://' + value)
    return url.toString()
  } catch (e) {
    console.error('bad url', value)
    return undefined
  }
}

export class PoweredOptions {
  readonly by: string | undefined
  readonly url: string | undefined

  static fromOptions(options: Options): undefined | PoweredOptions {
    const footer = extractFooter(options.footer)
    if (footer.on === false) return undefined
    return new PoweredOptions(footer)
  }

  constructor(json: Footer) {
    const { by, url } = json
    this.by = by?.trim() || undefined
    this.url = buildLink(url?.trim())
  }
}
